import React, { useState, useEffect } from 'react'
import { PanGestureHandler, State } from 'react-native-gesture-handler'
import PropTypes from 'prop-types'

import useStyles from './useStyles'
import { useTheme } from '../../theming/ThemeProvider'
import { View, Animated, Platform, SafeAreaView } from 'react-native'
import IconButton from '../IconButton'
import Identity from '../../utils/Identity'

const Drawer = ({ open, onChange, children, width }) => {
  const [translateX] = useState(new Animated.Value(open ? 0 : width))
  const { theme } = useTheme()
  const styles = useStyles(theme)

  useEffect(() => {
    Animated.timing(translateX, {
      toValue: open ? 0 : width,
      duration: 300,
      useNativeDriver: true
    }).start()
  }, [open, translateX, width])

  const onGestureEvent = Animated.event([
    {
      nativeEvent: {
        translationX: translateX
      }
    }
  ])

  const onHandlerStateChange = (event) => {
    if (event.nativeEvent.oldState === State.ACTIVE) {
      onChange(false)
    }
  }

  const translateXInterpolate = translateX.interpolate({
    inputRange: [-5000, 0, 5000],
    outputRange: [0, 0, 5000]
  })

  return (
    <PanGestureHandler
      onGestureEvent={onGestureEvent}
      onHandlerStateChange={onHandlerStateChange}
      enabled={Platform.OS !== 'web'}
    >
      <Animated.View
        style={[
          styles.container,
          Identity.Shadow(theme).Card,
          {
            height: '100%',
            width,
            transform: [{ translateX: translateXInterpolate }]
          }
        ]}
      >
        {Platform.OS !== 'web' && (
          <View style={styles.header}>
            <SafeAreaView />
            <IconButton
              icon='Exit'
              onPress={() => onChange(false)}
              color='WHITE'
              iconColor='OUTER_SPACE'
            />
          </View>
        )}
        {children}
      </Animated.View>
    </PanGestureHandler>
  )
}

Drawer.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.any,
  onChange: PropTypes.func,
  width: PropTypes.number
}

export default Drawer
